<template>
  <div class="progress-bar-container">
    <div
      class="progress-bar"
      :class="[`progress-${color}`, { 'progress-animated': animated }]"
      :style="{ height: height }"
    >
      <div
        class="progress-bar-fill"
        :style="{ width: `${Math.min(percentage, 100)}%` }"
      />
    </div>
    <div v-if="showLabel" class="progress-label">
      <span class="progress-percentage">{{ Math.round(percentage) }}%</span>
      <span v-if="showAmount && amount" class="progress-amount">
        {{ formatCurrency(amount) }}
      </span>
    </div>
  </div>
</template>

<script>
import { formatCurrency } from '../../utils/formatters';

export default {
  name: 'ProgressBar',
  props: {
    percentage: {
      type: Number,
      required: true,
      default: 0,
    },
    color: {
      type: String,
      default: 'primary',
      validator: (value) => ['primary', 'success', 'warning', 'danger', 'neutral'].includes(value),
    },
    height: {
      type: String,
      default: '8px',
    },
    showLabel: {
      type: Boolean,
      default: false,
    },
    showAmount: {
      type: Boolean,
      default: false,
    },
    amount: {
      type: Number,
      default: null,
    },
    animated: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    formatCurrency,
  },
};
</script>

<style lang="scss" scoped>
@import '../../scss/variable.scss';

.progress-bar-container {
  width: 100%;
}

.progress-bar {
  width: 100%;
  background-color: #E0E0E0;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
}

.progress-bar-fill {
  height: 100%;
  border-radius: 4px;
  transition: width 0.3s ease;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      45deg,
      rgba(255, 255, 255, 0.1) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.1) 50%,
      rgba(255, 255, 255, 0.1) 75%,
      transparent 75%,
      transparent
    );
    background-size: 20px 20px;
  }
}

.progress-animated .progress-bar-fill::after {
  animation: progress-stripes 1s linear infinite;
}

.progress-primary .progress-bar-fill {
  background: linear-gradient(90deg, $primary, lighten($primary, 10%));
}

.progress-success .progress-bar-fill {
  background: linear-gradient(90deg, $success, lighten($success, 10%));
}

.progress-warning .progress-bar-fill {
  background: linear-gradient(90deg, #FF9800, lighten(#FF9800, 10%));
}

.progress-danger .progress-bar-fill {
  background: linear-gradient(90deg, $primary, lighten($primary, 10%));
}

.progress-neutral .progress-bar-fill {
  background: linear-gradient(90deg, $grey, lighten($grey, 10%));
}

.progress-label {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 4px;
  font-size: 12px;
  color: $grey;
}

.progress-percentage {
  font-weight: 600;
  color: $black;
}

.progress-amount {
  font-weight: 600;
  color: $primary;
}

@keyframes progress-stripes {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 20px 0;
  }
}
</style>
